const state = {
    distributor: {
        data: []
    },
    distributors: [],
}
const actions = {
    showDistributors: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/distributors`).then(response => {
                context.commit('SHOW_DISTRIBUUTORS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showDistributor: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/distributors/${id}`).then(response => {
                context.commit('SHOW_DISTRIBUUTOR', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeDistributor: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/distributors`, payload).then(response => {
                context.commit('STORE_DISTRIBUUTOR', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateDistributor: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/distributors/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyDistributor: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/distributors/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_DISTRIBUUTOR: (state, payload) => {
        state.distributor = payload
    },
    SHOW_DISTRIBUUTORS: (state, payload) => {
        state.distributors = payload
    },
    STORE_DISTRIBUUTOR: (state, payload) => {
        state.distributor = payload
    }
}
const getters = {
    distributor: state => {
        return state.distributor
    },
    distributors: state => {
        return state.distributors
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}